export class BomIdRequest{
    packingMaterialId:number;
    isActive?:boolean;
    poQty?:number;
    fromPo:boolean;
    constructor(packingMaterialId:number, isActive?:boolean, poQty?:number, fromPo?:boolean){
        this.packingMaterialId = packingMaterialId;
        this.isActive = isActive;
        this.poQty = poQty;
        this.fromPo = fromPo;
    }
}